<template>
  <div :class="bem({'loading': shopifyStore.loading})">
    <div :class="bem('title-container')">
      <span
        :class="bem('title')"
      >
        Gift Card
      </span>
      
      <span
        v-if="giftCard"
        :class="bem('coupon')"
        @click="removeGiftCard"
      >
        <VisionIcon
          icon="gift"
          colour="black"
          size="xx-small"
        />
        <span :class="bem('coupon-code')">{{ giftCard.lastCharacters }}</span>
        <VisionIcon
          icon="cross"
          colour="black"
          size="xx-small"
          :class="bem('remove-icon')"
        />
      </span>
    </div>
    <span
      id="discount-value"
      :class="bem('total')"
    >
      {{ $tcl(usedAmount) }}
    </span>
  </div>
</template>

<script setup lang="ts">
const bem = useBEM('CartGiftCard')
const shopifyStore = useShopifyStore()

const giftCard = computed(() => {
  return shopifyStore.giftCard
})

const usedAmount = computed(() => {
  return (0 - Number(giftCard.value.amountUsed?.amount))
})

async function removeGiftCard() {
  await shopifyStore.updateGiftCard({
    code: '',
    silent: true,
  })
}
</script>
<style lang="postcss">
.CartGiftCard {
  @apply flex justify-between items-center;

  &--loading {
    @apply pointer-events-none opacity-40;
  }
}

.CartGiftCard__title {
  @apply text-grey-500 text-xs;
}

.CartGiftCard__title-container {
  @apply flex items-center;
}

.CartGiftCard__coupon {
  @apply flex gap-1 ml-2 uppercase text-xxs cursor-pointer hover:opacity-60;
}

.CartGiftCard__total {
  @apply font-bold text-xs;
}
</style>